import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const VideoJS = /*#__PURE__*/forwardRef((props, ref) => {
  const videoNodeRef = useRef(null);
  const playerRef = useRef(null);
  const {
    options,
    onReady
  } = props;
  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = videoNodeRef.current;
      if (!videoElement) return;
      const player = playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
      });
      player.on('play', () => {
        props.onPlay && props.onPlay(videoElement);
      });
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, videoNodeRef, onReady, props]);
  useImperativeHandle(ref, () => ({
    jumpTo: seconds => {
      if (playerRef.current) {
        playerRef.current.currentTime(seconds);
      }
    },
    play: () => {
      if (playerRef.current) {
        playerRef.current.play();
      }
    },
    pause: () => {
      if (playerRef.current) {
        playerRef.current.pause();
      }
    }
  }));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      "data-vjs-player": true,
      className: "video-wrapper",
      children: /*#__PURE__*/_jsx("video", {
        ref: videoNodeRef,
        className: "video-js vjs-big-play-centered"
      })
    })
  });
});
VideoJS.displayName = 'VideoJS';
export default VideoJS;